import { StyleSheet, View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';

const styles = StyleSheet.create({
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
});

export const ExportCommentarySubsection = ({
  title,
  subtitle,
  wrap = true,
  children,
}: PropsWithChildren<{ title: string; subtitle: string; wrap?: boolean }>) => (
  <View style={styles.sectionContainer} wrap={wrap}>
    <View style={styles.titleContainer}>
      <Text variant="h2">{title}</Text>
      <Text variant="body1">{subtitle}</Text>
    </View>

    {children}
  </View>
);
